import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import {
  fehHomebatteryStoreSelectorKey,
  reducers,
} from './feh-homebattery.state';
import { HomebatteryAdviceFormEffects } from './advice/homebattery-advice-form.effects';
import { HomeBatteryFunnelEffects } from './funnel/homebattery-funnel.effects';
import { HomeBatteryWizardEffects } from './wizard/homebattery-wizard.effects';
import { HomebatteryQuestionnaireEffects } from './questionnaire/homebattery-questionnaire.effects';
import { HomebatteryCapacityEffects } from './capacity/homebattery-capacity.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(fehHomebatteryStoreSelectorKey, reducers),
    EffectsModule.forFeature([
      HomeBatteryFunnelEffects,
      HomeBatteryWizardEffects,
      HomebatteryAdviceFormEffects,
      HomebatteryQuestionnaireEffects,
      HomebatteryCapacityEffects,
    ]),
  ],
})
export class FehHomebatteryStoreModule {}
